module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-100.953d760.woff2";